import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { isNullOrUndefined, isNull } from 'util';
import 'rxjs/add/operator/first';
import { UpdateCacheService } from '../../providers/update-cache.service';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css']
})
export class IntegrationsComponent implements OnInit, AfterViewInit, OnDestroy {
  key: string;
  locKey: string;
  showLoading = true;
  showSpinner = false;
  clientData: Client;
  selectedLocation: LocationInfo;
  locationsData: (LocationInfo | any)[];

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public router: Router,
    private cache: UpdateCacheService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        this.afService.getLocations(this.clientData).subscribe(locationsData => {
          this.locationsData = [{
            name: 'All',
            xpsInfo: this.clientData.xpsInfo,
            facebookPixelInfo: this.clientData.facebookPixelInfo,
            podiumInfo: this.clientData.podiumInfo
          }, ...locationsData];
          this.showLoading = false;
        });
      });
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
  }

  updateProductSets() {
    this.showSpinner = true;
    let sub = this.cache.updateAvailableUnitsCache(this.clientData.code, 'sitelink', true).subscribe(() => {
      sub.unsubscribe();
      this.showSpinner = false;
      this.afService.openSnackBar('Product sets updated successfully.');
    }, err => {
      this.showSpinner = false;
      console.log(err)
      this.afService.openSnackBar('Product sets updated successfully.');
    });
  }

  changeLocation(location) {
    if (isNullOrUndefined(location.xpsInfo)) {
      location.xpsInfo = {};
    }
    if (isNullOrUndefined(location.facebookPixelInfo)) {
      location.facebookPixelInfo = {};
    }
    if (isNullOrUndefined(location.podiumInfo)) {
      location.podiumInfo = {};
    }
    this.selectedLocation = location;
  }

  save() {
    if (this.selectedLocation.name === 'All') {
      this.clientData.xpsInfo = this.locationsData[0].xpsInfo;
      this.clientData.facebookPixelInfo = this.locationsData[0].facebookPixelInfo;
      this.clientData.podiumInfo = this.locationsData[0].podiumInfo;

      this.afService.updateClientXps(this.clientData).then(() => {
        this.afService.openSnackBar('Client successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
      this.afService.updateClientPixel(this.clientData).then(() => {
        this.afService.openSnackBar('Client successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
      this.afService.updateClientPodium(this.clientData).then(() => {
        this.afService.openSnackBar('Client successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }
    else {
      this.afService.updateLocationXps(this.clientData, this.selectedLocation).then(() => {
        this.afService.openSnackBar('Location successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
      this.afService.updateLocationPixel(this.clientData, this.selectedLocation).then(() => {
        this.afService.openSnackBar('Location successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
      this.afService.updateLocationPodium(this.clientData, this.selectedLocation).then(() => {
        this.afService.openSnackBar('Location successfully updated.');
      }).catch(e => {
        this.afService.openSnackBar(e.message);
      });
    }
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/integrations/integrations.component.ts